import { jsxs as o, jsx as l } from "react/jsx-runtime";
const a = (e) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          fillRule: "evenodd",
          d: "M5.7 17a1 1 0 0 1 1-1h4.6a1 1 0 1 1 0 2H6.7a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l("path", { fill: "#D9D9D9", d: "M6.7 17h4.6Z" }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          d: "M17 3a1 1 0 0 1 1 1 1 1 0 0 0 1 1 1 1 0 1 1 0 2 1 1 0 0 0-1 1 1 1 0 1 1-2 0 1 1 0 0 0-1-1 1 1 0 1 1 0-2 1 1 0 0 0 1-1 1 1 0 0 1 1-1"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          fillRule: "evenodd",
          d: "M9 6a6 6 0 0 0-3.662 10.753 2.5 2.5 0 0 1 .422.59q.03.084.076.161a2.5 2.5 0 0 1 .175 1.35A1 1 0 0 0 6 19a3 3 0 1 0 6 0 1 1 0 0 0-.01-.146 2.5 2.5 0 0 1 .174-1.35q.045-.076.076-.161.167-.326.422-.59A6 6 0 0 0 9 6m.989 12a4.5 4.5 0 0 0 .01 1.057 1 1 0 0 1-1.997 0A4.5 4.5 0 0 0 8.012 18z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          d: "M21 10a1 1 0 1 0-2 0 1 1 0 1 0 0 2 1 1 0 1 0 2 0 1 1 0 1 0 0-2"
        }
      )
    ]
  }
);
export {
  a as default
};
